import script from "./NewPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./NewPassword.vue?vue&type=script&setup=true&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=19ca3fc2&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19ca3fc2"]])

export default __exports__